<mat-select [matTooltip]="'OPPORTUNITY.PLEASE_SELECT_A_BUSINESS_UNIT' | translate"
  [matTooltipDisabled]="!!this.organizationId" [tabIndex]="tabIndex" [formControl]="selectCtrl"
  (selectionChange)="onSelectionChange()">
  <mat-option *ngFor="let opportunityType of opportunityTypes" [value]="opportunityType.opportunityTypeId">{{
    opportunityType.name }}</mat-option>
</mat-select>

<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>